"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VerticalContext = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _queryString = _interopRequireDefault(require("query-string"));

var _history = require("history");

var _Verticals = _interopRequireDefault(require("../../components/Verticals"));

var _Authentication = require("../Authentication");

var _Route = require("../Route");

var _vertical3 = require("@jobmatchme/utils/es/types/vertical");

var _resources = require("./resources");

var _hooks = require("@jobmatchme/suspendable-resource/es/hooks");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var VerticalContext = /*#__PURE__*/(0, _react.createContext)({
  verticals: [],
  vertical: undefined,
  setVertical: function setVertical() {},
  setVerticals: function setVerticals() {},
  fetchVerticals: function fetchVerticals() {}
});
exports.VerticalContext = VerticalContext;

/* MARKETING START:
 *
 *  This is only added for marketing so that they can build dynamic audiences
 * in Facebook based on the event URL
 */
var MARKETING_VERTICAL_ID = {
  truck: 'fahrer',
  care: 'pflege',
  'logistics-scheduler': 'disponenten',
  'service-gastro': 'service-gastro'
};

var updateQueryParam = function updateQueryParam(selectedVertical) {
  var history = (0, _history.createBrowserHistory)();
  var location = history.location;

  var parsedQueryString = _queryString.default.parse(location.search);

  parsedQueryString.vertical = MARKETING_VERTICAL_ID[selectedVertical];
  history.replace({
    pathname: location.pathname,
    search: _queryString.default.stringify(parsedQueryString)
  });
};
/* MARKETING END */


var updateVerticalInLocalStorage = function updateVerticalInLocalStorage(selectedVertical) {
  try {
    if (typeof selectedVertical === 'undefined') {
      localStorage.removeItem('selectedVertical');
    } else {
      localStorage.setItem('selectedVertical', selectedVertical);
    }
  } catch (error) {
    return console.error('Error: ', error);
  }
};

var setVerticalParams = function setVerticalParams(selectedVertical) {
  updateVerticalInLocalStorage(selectedVertical);

  if (typeof selectedVertical !== 'undefined') {
    updateQueryParam(selectedVertical);
  }
};

var getVerticalFromLocalStorage = function getVerticalFromLocalStorage() {
  try {
    var _vertical = localStorage.getItem('selectedVertical');

    return _vertical && (0, _vertical3.isVerticalType)(_vertical) ? _vertical : undefined;
  } catch (error) {
    console.error('Error: ', error);
  }
};

var getVerticalParam = function getVerticalParam() {
  var localStorageVertical = getVerticalFromLocalStorage();
  if (localStorageVertical) return localStorageVertical;
  var history = (0, _history.createBrowserHistory)();
  var location = history.location;

  var parsedQueryString = _queryString.default.parse(location.search);

  if (parsedQueryString.vertical) {
    var _vertical2 = Object.keys(MARKETING_VERTICAL_ID).find(function (key) {
      return MARKETING_VERTICAL_ID[key] === parsedQueryString.vertical;
    }) || Object.keys(MARKETING_VERTICAL_ID).find(function (key) {
      return key === parsedQueryString.vertical;
    });

    return _vertical2 && (0, _vertical3.isVerticalType)(_vertical2) ? _vertical2 : undefined;
  }
};

var selectVerticalFromResource = function selectVerticalFromResource(resource) {
  if ((resource === null || resource === void 0 ? void 0 : resource.length) === 1) {
    return resource[0];
  } else {
    var fromParam = getVerticalParam();
    return typeof fromParam !== 'undefined' && (resource === null || resource === void 0 ? void 0 : resource.indexOf(fromParam)) !== -1 ? fromParam : undefined;
  }
};

var VerticalsResource = (0, _resources.getVertcalsResource)();

var VerticalProvider = function VerticalProvider(_ref) {
  var children = _ref.children,
      fixedVertical = _ref.fixedVertical;

  var _useResource = (0, _hooks.useResource)(fixedVertical ? VerticalsResource.prepareAsUndefined() : VerticalsResource.prepare()),
      _useResource2 = (0, _slicedToArray2.default)(_useResource, 3),
      verticals = _useResource2[0],
      setLocalVerticals = _useResource2[2];

  var _useState = (0, _react.useState)(fixedVertical || selectVerticalFromResource(verticals)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      vertical = _useState2[0],
      setVerticalState = _useState2[1];

  var _useContext = (0, _react.useContext)(_Authentication.AuthenticationContext),
      isAuthenticated = _useContext.isAuthenticated;

  var _useContext2 = (0, _react.useContext)(_Route.RouteActionsContext),
      routeInternal = _useContext2.routeInternal;

  var setVertical = (0, _react.useCallback)(function (v) {
    setVerticalState(v);
    setVerticalParams(v);
  }, []);
  var fetchVerticals = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var noReroute,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            noReroute = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            (0, _resources.fetchVerticalsPromise)().then(function (response) {
              setLocalVerticals(response);

              if (response) {
                if (response.length === 1) {
                  setVertical(response[0]);
                } else if (response.length === 0) {
                  if (!noReroute) {
                    routeInternal('vertical');
                  }
                } else {
                  var selectedVertical = getVerticalParam();

                  if (typeof selectedVertical !== 'undefined' && response.indexOf(selectedVertical) !== -1) {
                    setVertical(selectedVertical);
                  }
                }
              }
            }).catch(function (e) {
              console.error(e);
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [routeInternal, setVertical, setLocalVerticals]);
  (0, _react.useEffect)(function () {
    if (isAuthenticated && verticals && !vertical) {
      setVerticalParams(vertical);

      if (verticals.length === 0 && !vertical) {
        routeInternal('vertical');
      }
    }
  }, [verticals, isAuthenticated, routeInternal, vertical]);
  var state = (0, _react.useMemo)(function () {
    return {
      vertical: vertical,
      verticals: verticals,
      setVertical: setVertical,
      setVerticals: setLocalVerticals,
      fetchVerticals: fetchVerticals
    };
  }, [vertical, verticals, setLocalVerticals, fetchVerticals, setVertical]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(VerticalContext.Provider, {
    value: state,
    children: vertical ? children : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Verticals.default, {
      verticals: verticals,
      setVertical: setVerticalParams
    })
  });
};

var _default = VerticalProvider;
exports.default = _default;